import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { doGetSession } from "../../utilities";

function PublicNavbar({ user_session }) {
    const router = useRouter();
    const [user, setUser] = React.useState(null);
    const [isLoggedIn, setIsLoggedIn] = React.useState(false);
    React.useEffect(() => {
        // doGetSession().then((session) => {
        if (user_session && user_session?.user) {
            setUser(user_session?.user);
            setIsLoggedIn(true);
        }
        // })
    }, []);
    return (
        <>
            {(window.location.hostname.includes("-pilot") ||
                window.location.hostname.includes("-training") ||
                window.location.hostname.includes("localhost")) && (
                <div
                    style={{
                        padding: "4px",
                        textAlign: "center",
                        zIndex: 9999,
                        position: "fixed",
                        backgroundColor: "white",
                        width: "100vw",
                        borderBottom: "1px solid #ccc",
                    }}
                >
                    <small>
                        This is a training instance of the ePT platform for
                        testing and training purposes only. For the live site,
                        go to{" "}
                        <Link href={"https://ept.nphl.go.ke"} target="_blank">
                            https://ept.nphl.go.ke
                        </Link>
                    </small>
                </div>
            )}
            <nav
                style={{
                    top:
                        window.location.hostname.includes("-pilot") ||
                        window.location.hostname.includes("-training") ||
                        window.location.hostname.includes("localhost")
                            ? "25px"
                            : "0px",
                }}
                className="navbar navbar-expand-lg navbar-light fixed-top bg-light public-nav border-bottom"
            >
                <div className="container">
                    <Link href="/" className="navbar-brand">
                        EPT
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#appNavbarToggler"
                        aria-controls="appNavbarToggler"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div
                        className="collapse navbar-collapse"
                        id="appNavbarToggler"
                    >
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {" "}
                            {/* home, about, scopes, calendar, certification, learning centre */}
                            <li className="nav-item mx-md-2">
                                <Link
                                    href="/"
                                    className={
                                        "nav-link " +
                                        (router.pathname === "/"
                                            ? " active"
                                            : "")
                                    }
                                >
                                    Home
                                </Link>
                            </li>
                            <li className="nav-item mx-md-2">
                                <Link
                                    href="/about"
                                    className={
                                        "nav-link " +
                                        (router.pathname === "/about"
                                            ? " active"
                                            : "")
                                    }
                                >
                                    About
                                </Link>
                            </li>
                            <li className="nav-item mx-md-2">
                                <Link
                                    href="/scopes"
                                    className={
                                        "nav-link " +
                                        (router.pathname === "/scopes"
                                            ? " active"
                                            : "")
                                    }
                                >
                                    Scopes
                                </Link>
                            </li>
                            <li className="nav-item mx-md-2">
                                <Link
                                    href="/calendar"
                                    className={
                                        "nav-link " +
                                        (router.pathname === "/calendar"
                                            ? " active"
                                            : "")
                                    }
                                >
                                    Calendar
                                </Link>
                            </li>
                            {/* <li className="nav-item mx-md-2">
                                <Link legacyBehavior href="/certification"><a className={"nav-link " + (router.pathname === '/certification' ? ' active' : '')}>Certification</a></Link>
                            </li> */}
                            <li className="nav-item mx-md-2">
                                <Link
                                    href="/learning-centre"
                                    className={
                                        "nav-link " +
                                        (router.pathname === "/learning-centre"
                                            ? " active"
                                            : "")
                                    }
                                >
                                    Learning Centre
                                </Link>
                            </li>
                        </ul>
                        {isLoggedIn && user ? (
                            <div className="text-end d-flex">
                                <div className="d-flex flex-wrap align-items-center">
                                    <small className="text-light me-2">
                                        {user.name}
                                    </small>
                                    <button
                                        className="btn btn-sm btn-outline-light"
                                        onClick={(ev) => {
                                            doLogout(router);
                                        }}
                                    >
                                        Log out
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="text-end d-flex">
                                <Link
                                    href="/auth/login"
                                    style={{ whiteSpace: "nowrap" }}
                                    className="btn btn-outline-primary px-4 me-2 fw-semibold"
                                >
                                    Log in
                                </Link>
                                <Link
                                    href="/auth/signup"
                                    style={{ whiteSpace: "nowrap" }}
                                    className="btn btn-primary px-4 fw-semibold"
                                >
                                    Enrol now
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </nav>
        </>
    );
}

export default PublicNavbar;
